import React from 'react';

export const ArtsPage = React.lazy(() => (
  import('./ArtsPage')
));
